module.exports = __webpack_public_path__ + "static/media/tab5.fa572f31.svg";